import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type UserProfile = {
  id: string;
  user_id: string;
  statut_fiscal: string;
  anciennete: string | null;
  created_at: string | null;
  tarif_seance: number | null;
  nb_patients_semaine: number | null;
  target_monthly_ca: number | null;
  estimated_monthly_charges: number | null;
  average_session_rate: number | null;
  plan: string | null;
  stripe_subscription_status: string | null;
  semaines_travaillees: number | null;
  has_completed_onboarding: boolean | null;
};

export function useProfile() {
  const { user, loading: authLoading } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    if (!user) { setProfile(null); setLoading(false); return; }
    const { data, error } = await supabase
      .from("profils")
      .select("*")
      .eq("user_id", user.id)
      .maybeSingle();
    if (error && import.meta.env.DEV) console.error("❌ useProfile:", error.message);
    setProfile(data as unknown as UserProfile | null);
    setLoading(false);
  };

  useEffect(() => {
    if (authLoading) return;
    fetchProfile();
  }, [user, authLoading]);

  return { profile, loading, refetch: fetchProfile };
}
